function sizeToCSS(size) {
  let cssSize;
  if (size) {
    cssSize = size.size;
    if (size.isAbsolute) {
      cssSize += "px";
    } else {
      cssSize += "%";
    }
  }
  return cssSize;
}
export {
  sizeToCSS as s
};
